import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnInit} from '@angular/core';
import {SchedulingService} from '../../modules/scheduling/scheduling.service';
import {Globals} from '../../globals';
import {DataAppointmentModel} from '../../models/appointments/data-appointment.model';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Constants} from '../../constants';
import {StaticDataService} from '../../services/static-data.service';
import {EnumValidValueItemModel} from '../../models/enum/enum-valid-value-item.model';
import {DoctorsService} from '../../services/doctors.service';
import {DoctorSummaryModel} from '../../models/doctors/doctor-summary.model';
import {DoctorQueryOptionsModel} from '../../models/doctors/doctor-query-options.model';

@Component({
  standalone: false,
  selector: 'app-all-patient-appointments-dialog',
  templateUrl: './all-patient-appointments-dialog.component.html',
  styleUrls: ['./all-patient-appointments-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AllPatientAppointmentsDialogComponent implements OnInit {
  appointments: DataAppointmentModel[] = [];
  currentCaseApppointments: DataAppointmentModel[] = [];
  enumApptType: EnumValidValueItemModel[] = [];
  procedureTypeEnums: EnumValidValueItemModel[] = [];
  enumApptStatusEnums: EnumValidValueItemModel[] = [];
  doctors: DoctorSummaryModel[] = [];

  constructor(private schedulingService: SchedulingService,
              private staticDataService: StaticDataService,
              private globals: Globals,
              private doctorService: DoctorsService,
              private cdr: ChangeDetectorRef,
              private dialogRef: MatDialogRef<AllPatientAppointmentsDialogComponent>,
              @Inject(MAT_DIALOG_DATA) private data: DataAppointmentModel[]) {
    this.currentCaseApppointments = data;
  }

  ngOnInit(): void {
    if (this.staticDataService.isReady) {
      this.enumApptType = this.staticDataService.getValidValueItemsByValidValueName('enumApptType');
      this.procedureTypeEnums = this.staticDataService.getValidValueItemsByValidValueName('enumProcedureType');
      this.enumApptStatusEnums = this.staticDataService.getValidValueItemsByValidValueName('enumApptStatus');
    } else {
      this.staticDataService.validValuesReadyEvent.subscribe({
        complete: () => {
          this.enumApptType = this.staticDataService.getValidValueItemsByValidValueName('enumApptType');
          this.procedureTypeEnums = this.staticDataService.getValidValueItemsByValidValueName('enumProcedureType');
          this.enumApptStatusEnums = this.staticDataService.getValidValueItemsByValidValueName('enumApptStatus');
          this.cdr.markForCheck();
        }
      });
    }

    const docOptions = new DoctorQueryOptionsModel();
    docOptions.isIncludeTdo = true;
    docOptions.isIncludeReferring = true;
    this.doctorService.getDoctorsSummary(docOptions).subscribe((docRes) => {
      this.doctors = docRes;
      this.cdr.markForCheck();
    });
    this.schedulingService.getAllPatientAppointments(this.globals.currentPatientId).subscribe((res) => {
      this.appointments = res;
      this.cdr.markForCheck();
    });
  }

  onOkClick() {
    this.dialogRef.close();
  }

  getWeekDay(StartDate: Date) {
    const d = new Date(StartDate);
    const day = Constants.weekDays[d.getDay()];
    return day;
  }

  getAppointmentType(enumApptTypeId: string) {
    const enu = this.enumApptType.find(p => p.ValidValueItemId.toLowerCase() === enumApptTypeId.toLowerCase());
    if (enu) {
      return enu.ItemDisplayValue;
    }

    return '';
  }
  getAppointmentStatus(enumApptStatusId: string) {
    const enu = this.enumApptStatusEnums.find(p => p.ValidValueItemId.toLowerCase() === enumApptStatusId.toLowerCase());
    if (enu) {
      return enu.ItemDisplayValue;
    }

    return '';
  }


  getProcedureType(enumProcedureTypeID: string) {
    const enu = this.procedureTypeEnums.find(p => p.ValidValueItemId.toLowerCase() === enumProcedureTypeID.toLowerCase());
    if (enu) {
      return enu.ItemDisplayValue;
    }

    return '';
  }

  getDoctor(doctorId: string) {
    const doctor = this.doctors.find(p => p.DoctorId.toLowerCase() === doctorId);
    if (doctor) {
      return 'Dr. ' + doctor.dataContact.LastName;
    }

    return '';
  }

  isCurrentCaseAppointment(appointment: DataAppointmentModel) {
    const currentAppointmentIds = this.currentCaseApppointments.map(p => p.AppointmentId);
    // const current = this.appointments.filter(p => currentAppointmentIds.includes(appointment.AppointmentId));
    return currentAppointmentIds.includes(appointment.AppointmentId);
  }
}
